<template>
  <div>
      <v-row>
        <v-col cols="12" sm="4">
            <v-text-field
                v-model="data[leg].input_directFlight_FlightNo"
                name="input_directFlight_FlightNo"
                class="uppercase"
                :rules ="[
                    showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_directFlight_FlightNo, data[leg].input_FlightTypeTab === 0),
                    (showDeleteCheckbox && (data[leg].input_directFlight_FlightNo === '')) ? true : rules.min(2, data[leg].input_directFlight_FlightNo),
                    (showDeleteCheckbox && (data[leg].input_directFlight_FlightNo === '')) ? true : rules.max(8, data[leg].input_directFlight_FlightNo),
                    (showDeleteCheckbox && (data[leg].input_directFlight_FlightNo === '')) ? true : rules.isFlightNo(data[leg].input_directFlight_FlightNo),
                ]"
                maxlength="8"
                counter
                prepend-icon="mdi-numeric"
                clearable
                :hint="'ATC Call Sign: ' + data[leg].input_directFlight_AtcCallSign"
                persistent-hint
                @input="onChange_FlightNo">
                <template v-slot:label>
                    <p>
                        Flight# <span style="color: red; font-size: 1.4rem;">*</span>
                    </p>
                </template>
            </v-text-field>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="4">
            <v-combobox
                v-model="data[leg].input_directFlight_AirportDeparture"
                class="uppercase"
                :items="get_Airports"
                item-value="iataCode"
                item-text="iataCode"
                prepend-icon="mdi-airplane-takeoff"
                clearable
                :rules ="[
                    showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_directFlight_AirportDeparture, data[leg].input_FlightTypeTab === 0),
                ]"
                @input="onChange_directFlight_Departure(); onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                <template v-slot:label>
                    <p>
                    Airport Departure <span style="color: red; font-size: 1.4rem;">*</span>
                    </p>
                </template>
            </v-combobox>
        </v-col>

        <v-col cols="12" sm="4">
            <v-combobox
                v-model="data[leg].input_directFlight_AirportDestination"
                class="uppercase"
                :items="get_Airports"
                item-value="iataCode"
                item-text="iataCode"
                prepend-icon="mdi-airplane-landing"
                clearable
                :rules ="[
                    showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_directFlight_AirportDestination, data[leg].input_FlightTypeTab === 0),
                ]"
                @input="onChange_directFlight_Destination(); onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                <template v-slot:label>
                    <p>
                    Airport Destination <span style="color: red; font-size: 1.4rem;">*</span>
                    </p>
                </template>
            </v-combobox>
        </v-col>
    </v-row>

    <!-- >>> Row - AB -->
    <div style="margin-top: 60px;">
        <p class="font-weight-bold mb-0">
            AB Times
        </p>
        <v-row v-if="get_flights_OCCMode">
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="data[leg].input_AB_Time_Departure_Actual"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    label="AB Time Departure (Actual)"
                    @input="onChange_checkForOvernight(); onChange_ActualTime('AB_DEPARTURE')" />
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="data[leg].input_AB_Time_Arrival_Actual"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    label="AB Time Arrival (Actual)"
                    @input="onChange_checkForOvernight(); onChange_ActualTime('AB_ARRIVAL')" />
            </v-col>
        </v-row>

        <!-- TODO: if times/slots changes: do something with email -->
        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="data[leg].input_AB_Time_Departure_Scheduled"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_AB_Time_Departure_Scheduled, data[leg].input_FlightTypeTab === 0),
                    ]"
                    @input="onChange_checkForOvernight(); onChange_fillBlockTimes('input_AB_Time_Departure_Scheduled')">
                    <template v-slot:label>
                        <p>
                        AB Time Departure (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="data[leg].input_AB_Time_Arrival_Scheduled"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    :rules ="[
                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_AB_Time_Arrival_Scheduled, data[leg].input_FlightTypeTab === 0),
                    ]"
                    @input="onChange_checkForOvernight(); onChange_autoFillTurnaroundTime('input_AB_Time_Arrival_Scheduled', leg)">
                    <template v-slot:label>
                        <p>
                        AB Time Arrival (Scheduled) <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                <v-text-field
                    v-model="data[leg].input_AB_Slot_Departure"
                    :tabindex="get_flights_OCCMode ? '-1' : ''"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    label="AB Slot Departure"
                    :hint="createMissingSlotString('input_directFlight_AirportDeparture', 'input_AB_Slot_Departure', 'input_AB_Time_Departure_Scheduled')"
                    persistent-hint
                    @change="onChange_setSlotRequestStatus('input_AB_Departure_SlotStatus', $refs['input_AB_Departure_SlotStatus'])" />
            </v-col>

            <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div multiple v-on="on">
                            <v-checkbox
                                v-model="input_Delete_AB_Slot_Departure"
                                off-icon="mdi-trash-can-outline"
                                on-icon="mdi-trash-can-outline"
                                @change="v => onChange_deleteForAll(leg, v, 'AB_SLOT_DEPARTURE', 'input_AB_Slot_Departure')" />
                        </div>
                    </template>
                    <span>Delete for all</span>
                </v-tooltip>
            </v-col>

            <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                <v-text-field
                    v-model="data[leg].input_AB_Slot_Arrival"
                    :tabindex="get_flights_OCCMode ? '-1' : ''"
                    prepend-icon="mdi-clock-time-four-outline"
                    type="time"
                    label="AB Slot Arrival"
                    :hint="createMissingSlotString('input_directFlight_AirportDestination', 'input_AB_Slot_Arrival', 'input_AB_Time_Arrival_Scheduled')"
                    persistent-hint
                    @change="onChange_setSlotRequestStatus('input_AB_Arrival_SlotStatus', $refs['input_AB_Arrival_SlotStatus'])" />
            </v-col>

            <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div multiple v-on="on">
                            <v-checkbox
                                v-model="input_Delete_AB_Slot_Arrival"
                                off-icon="mdi-trash-can-outline"
                                on-icon="mdi-trash-can-outline"
                                @change="v => onChange_deleteForAll(leg, v, 'AB_SLOT_ARRIVAL', 'input_AB_Slot_Arrival')" />
                        </div>
                    </template>
                    <span>Delete for all</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                <v-select
                    ref="input_AB_Departure_SlotStatus"
                    v-model="data[leg].input_AB_Departure_SlotStatus"
                    :items="items_slotRequestStatus"
                    prepend-icon="mdi-send-check"
                    class="slotRequestStatus">
                    <template v-slot:label>
                        <p>
                        AB Departure Slot Request Status
                        </p>
                    </template>
                </v-select>
            </v-col>

            <v-col v-if="showDeleteCheckbox" cols="12" sm="1" />

            <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                <v-select
                    ref="input_AB_Arrival_SlotStatus"
                    v-model="data[leg].input_AB_Arrival_SlotStatus"
                    :items="items_slotRequestStatus"
                    prepend-icon="mdi-send-check"
                    class="slotRequestStatus">
                    <template v-slot:label>
                        <p>
                        AB Arrival Slot Request Status
                        </p>
                    </template>
                </v-select>
            </v-col>
        </v-row>
    </div>
    <!-- <<< Row - AB -->
  </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../../main';


    export default {
        name: 'SdrStep3RouteconfigDirectflight',


        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire rules Object
            showDeleteCheckbox: Boolean,
            onChange_FlightNo: Function, //
            onChange_directFlight_AirportDeparture: Function,
            onChange_directFlight_AirportDestination: Function,
            onChange_checkForOvernight: Function,
            onChange_fillBlockTimes: Function,
            onChange_autoFillTurnaroundTime: Function,
            onChange_ActualTime: Function,
            createMissingSlotString: Function,
            onChange_setSlotRequestStatus: Function

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                input_Delete_AB_Slot_Departure: false,
                input_Delete_AB_Slot_Arrival: false,
                items_slotRequestStatus: [
					{
						value: 'confirmed',
						text: 'Confirmed'
					},
					{
						value: 'pending',
						text: 'Pending'
					},
					{
						value: 'offered',
						text: 'Offered'
					},
					{
						value: 'refused',
						text: 'Refused'
					},
					{
						value: 'cancelled',
						text: 'Cancelled'
					}
				]
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([

                'get_flights_OCCMode',
                'get_Airports'

            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> created');
            eventBus.$on('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * onEmit_FlightWasUpdated()
            *
            * Desc: Reset Values after Flight Update
            * Note:
            *
            *
            */
            onEmit_FlightWasUpdated: function() {

                const me = this;


                me.input_Delete_AB_Slot_Departure = false;
                me.input_Delete_AB_Slot_Arrival = false;

            }, // eo function onEmit_FlightWasUpdated()


            /*******************************************************************
            * onChange_directFlight_Destination()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_directFlight_Departure: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> onChange_directFlight_Departure');
                if (Vue.prototype.$isEmpty(me.data[me.leg].input_directFlight_AirportDeparture)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.data[me.leg].input_directFlight_AirportDeparture !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_directFlight_AirportDeparture.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_directFlight_AirportDeparture.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.data[me.leg].input_directFlight_AirportDeparture = airport;
                } else {
                    me.data[me.leg].input_directFlight_AirportDeparture = '';
                }


                // trigger prop
                me.onChange_directFlight_AirportDeparture(me.data[me.leg].input_directFlight_AirportDeparture);

            }, // eo function onChange_directFlight_Departure()


            /*******************************************************************
            * onChange_directFlight_Destination()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_directFlight_Destination: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> onChange_directFlight_Destination');
                if (Vue.prototype.$isEmpty(me.data[me.leg].input_directFlight_AirportDestination)) {
                    return;
                }
                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.data[me.leg].input_directFlight_AirportDestination !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_directFlight_AirportDestination.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_directFlight_AirportDestination.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.data[me.leg].input_directFlight_AirportDestination = airport;
                } else {
                    me.data[me.leg].input_directFlight_AirportDestination = '';
                }


                // trigger prop
                me.onChange_directFlight_AirportDestination(this.data[this.leg].input_directFlight_AirportDestination);

            }, // eo function onChange_directFlight_Destination()


            /*******************************************************************
            * onChange_deleteForAll
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteForAll: function(leg, value, type, inputName) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/components/Step3RouteConfig_DirectFlight.vue >>> onChange_deleteForAll');
                me.data[me.leg][inputName] = '';
                eventBus.$emit('markToDeleteBus', { leg: leg, type: type, value: value });

            } // eo function onChange_deleteForAll()

        } // eof methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    .uppercase input {
        text-transform: uppercase !important;
    }
</style>

<style scoped>
    .slotRequestStatus >>> .v-select__selection {
		text-transform: none;
		color: rgba(0, 0, 0, 0.87);
		font-weight: 300;
		font-size: 1rem;
		max-width: 100%;
		margin: 0px;
	}

</style>
